import {
  Box,
  CircularProgress,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography
} from '@mui/material'
import {Suggestion} from '../hooks/useSearchAddress'
import {styles} from '../styles'

interface SuggestionsListProps {
  suggestions: Suggestion[]
  isLoading: boolean
  onSuggestionSelect: (suggestion: Suggestion) => void
}

export const SuggestionsList: React.FC<SuggestionsListProps> = ({
  suggestions,
  isLoading,
  onSuggestionSelect
}) => {
  if (isLoading) {
    return (
      <Box sx={styles.suggestionsLoadingContainer} data-test-id="suggestions-loading-container">
        <CircularProgress size={24} sx={{my: 3}} data-test-id="suggestions-loading-spinner" />
      </Box>
    )
  }

  if (suggestions.length === 0) {
    return null
  }

  return (
    <List sx={styles.suggestionsList} data-test-id="suggestions-list">
      {suggestions.map((suggestion, index) => {
        const isLastItem = index === suggestions.length - 1

        return (
          <ListItem
            key={suggestion.magicKey}
            sx={styles.suggestionItem}
            data-test-id={`suggestion-item-${index}`}
          >
            <ListItemButton
              onClick={() => onSuggestionSelect(suggestion)}
              sx={{
                ...styles.suggestionButton,
                borderBottom: isLastItem ? 'none' : '1px solid #e8ecf0'
              }}
              data-test-id={`suggestion-button-${index}`}
            >
              <ListItemText
                primary={
                  <Typography sx={styles.suggestionText} data-test-id={`suggestion-text-${index}`}>
                    {suggestion.text}
                  </Typography>
                }
                sx={styles.suggestionTextContainer}
              />
            </ListItemButton>
          </ListItem>
        )
      })}
    </List>
  )
}
